import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { MarketingShell } from "./layout/MarketingShell.js";
import { Home } from "./routes/Home.js";
import { Games } from "./routes/Games.js";
import { GameDetail } from "./routes/GameDetail.js";
import { Integration } from "./routes/Integration.js";
import { About } from "./routes/About.js";
import { Contact } from "./routes/Contact.js";
import { ResponsibleGaming } from "./routes/ResponsibleGaming.js";
import { Docs } from "./routes/Docs.js";
import { ApiReference } from "./routes/ApiReference.js";
import { Sdk } from "./routes/Sdk.js";
import { Webhooks } from "./routes/Webhooks.js";
import { Security } from "./routes/Security.js";
import { Transparency } from "./routes/Transparency.js";
import { Terms } from "./routes/legal/Terms.js";
import { Privacy } from "./routes/legal/Privacy.js";
import { NotFound } from "./routes/NotFound.js";
import { Admin } from "./routes/Admin.js";
import { Casino } from "./routes/Casino.js";
import { GameView } from "./GameView.js";
import { PressurePlate } from "./games/pressure-plate/PressurePlate.js";
import { CipherCrack } from "./games/cipher-crack/CipherCrack.js";
import { AgeGate } from "./components/AgeGate.js";
import { Operator } from "./routes/Operator.js";
import { Commission } from "./routes/Commission.js";
import { Status } from "./routes/Status.js";
import { FAQ } from "./routes/FAQ.js";
import { Sandbox } from "./routes/Sandbox.js";
import { PlayUnavailable } from "./routes/PlayUnavailable.js";
import { Roadmap } from "./routes/Roadmap.js";
import { Blog } from "./routes/Blog.js";
import { HowProvablyFairWorks } from "./routes/blog/HowProvablyFairWorks.js";
import { RevShareVsLicensing } from "./routes/blog/RevShareVsLicensing.js";
import { SpribeAlternative } from "./routes/blog/SpribeAlternative.js";
import { Book } from "./routes/Book.js";

const router = createBrowserRouter([
  {
    path: "/play",
    element: (
      <AgeGate>
        <GameView />
      </AgeGate>
    ),
  },
  {
    path: "/play/pressure-plate",
    element: (
      <AgeGate>
        <PressurePlate />
      </AgeGate>
    ),
  },
  {
    path: "/play/cipher-crack",
    element: (
      <AgeGate>
        <CipherCrack />
      </AgeGate>
    ),
  },
  {
    path: "/play/unavailable",
    element: <PlayUnavailable />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "/casino",
    element: (
      <AgeGate>
        <Casino />
      </AgeGate>
    ),
  },
  {
    element: <MarketingShell />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/games", element: <Games /> },
      { path: "/games/:slug", element: <GameDetail /> },
      { path: "/integration", element: <Integration /> },
      { path: "/docs", element: <Docs /> },
      { path: "/api-reference", element: <ApiReference /> },
      { path: "/sdk", element: <Sdk /> },
      { path: "/webhooks", element: <Webhooks /> },
      { path: "/security", element: <Security /> },
      { path: "/transparency/:operatorId", element: <Transparency /> },
      { path: "/about", element: <About /> },
      { path: "/contact", element: <Contact /> },
      { path: "/responsible-gaming", element: <ResponsibleGaming /> },
      { path: "/operator", element: <Operator /> },
      { path: "/commission", element: <Commission /> },
      { path: "/status", element: <Status /> },
      { path: "/faq", element: <FAQ /> },
      { path: "/sandbox", element: <Sandbox /> },
      { path: "/roadmap", element: <Roadmap /> },
      { path: "/book", element: <Book /> },
      { path: "/blog", element: <Blog /> },
      { path: "/blog/how-provably-fair-works", element: <HowProvablyFairWorks /> },
      { path: "/blog/rev-share-vs-licensing", element: <RevShareVsLicensing /> },
      { path: "/blog/spribe-alternative", element: <SpribeAlternative /> },
      { path: "/legal/terms", element: <Terms /> },
      { path: "/legal/privacy", element: <Privacy /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
